import React from 'react';
import { makeStyles } from '@material-ui/core';
import { colors } from '../../../theme';

const crossOutStyle = makeStyles({
  crossOut: {
    position: 'relative',
    '&::before': {
      position: 'absolute',
      content: '""',
      left: 0,
      top: '50%',
      right: 0,
      borderTop: '2px solid',
      borderColor: colors.bright_pink,
      transform: 'rotate(30.07deg)',
    },
  },
});

type CrossOutProps = {
  numberToCrossOut?: number;
  hasFreeQuota?: boolean;
  maxQuote: number;
};

const CrossOut = ({
  numberToCrossOut = 12,
  hasFreeQuota = false,
  maxQuote,
}: CrossOutProps): JSX.Element => {
  const classes = crossOutStyle();
  if (hasFreeQuota) {
    return (
      <>
        <span className={classes.crossOut} data-testid="number-with-cross-out">
          {numberToCrossOut}
        </span>{' '}
        {maxQuote}{' '}
      </>
    );
  }

  return (
    <>
      <span data-testid="number-without-cross-out">{maxQuote}</span>{' '}
    </>
  );
};

export default CrossOut;
